import { Text, type TextProps } from '@chakra-ui/react'

import ShwLink from '@/components/ShwLink'

import linkifyText from './linkifyText'

export default function TextWithLinks({
  text,
  ...props
}: TextProps & {
  text: string
}): React.ReactElement {
  const linkifiedText = linkifyText(text)

  return (
    <Text as="span" {...props}>
      {linkifiedText.map(textOrLink =>
        textOrLink.type === 'link' ? (
          <ShwLink
            key={textOrLink.value}
            href={textOrLink.value}
            isExternal
            color={props.color}
            fontWeight="normal"
            isUgc
          >
            {textOrLink.value}
          </ShwLink>
        ) : (
          textOrLink.value
        )
      )}
    </Text>
  )
}
